var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 115,
    viewBox: "0 0 114 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.80489C0 1.25579 1.25712 0 2.80787 0H111.192C112.743 0 114 1.25579 114 2.80489V76.2078C114 77.7569 112.743 79.0127 111.192 79.0127H72.0023C70.4516 79.0127 69.1945 77.7569 69.1945 76.2078C69.1945 74.6587 70.4516 73.4029 72.0023 73.4029H108.384V5.60977H5.61573V73.4029H40.1606C41.7114 73.4029 42.9685 74.6587 42.9685 76.2078C42.9685 77.7569 41.7114 79.0127 40.1606 79.0127H2.80787C1.25712 79.0127 0 77.7569 0 76.2078V2.80489Z",
    fill: "#2A5877"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.58 19.6786L2.80786 19.6786L2.80786 14.0688L110.58 14.0689L110.58 19.6786Z",
    fill: "#2A5877"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4634 16.2621V5.25171H98.0791V16.2621H92.4634Z",
    fill: "#2A5877"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4634 75.5961V64.5857H98.0791V75.5961H92.4634Z",
    fill: "#2A5877"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1548 16.2621V5.25171H82.7705V16.2621H77.1548Z",
    fill: "#2A5877"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1548 75.5961V64.5857H82.7705V75.5961H77.1548Z",
    fill: "#2A5877"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8464 16.2621V5.25171H67.4622V16.2621H61.8464Z",
    fill: "#2A5877"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5378 16.2621V5.25171H52.1536V16.2621H46.5378Z",
    fill: "#2A5877"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2295 16.2621V5.25171H36.8452V16.2621H31.2295Z",
    fill: "#2A5877"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6479 61.2774C27.8005 60.2411 29.5759 60.3345 30.6133 61.4859L41.6354 73.7197C42.6728 74.8712 42.5794 76.6447 41.4267 77.681C40.2741 78.7173 38.4987 78.6239 37.4613 77.4725L26.4392 65.2387C25.4018 64.0872 25.4952 62.3137 26.6479 61.2774Z",
    fill: "#2A5877"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6479 61.2774C27.8005 60.2411 29.5759 60.3345 30.6133 61.4859L41.6354 73.7197C42.6728 74.8712 42.5794 76.6447 41.4267 77.681C40.2741 78.7173 38.4987 78.6239 37.4613 77.4725L26.4392 65.2387C25.4018 64.0872 25.4952 62.3137 26.6479 61.2774Z",
    fill: "#2A5877"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4894 61.2774C59.6421 60.2411 61.4175 60.3345 62.4548 61.4859L73.477 73.7197C74.5144 74.8712 74.4209 76.6447 73.2683 77.681C72.1156 78.7173 70.3402 78.6239 69.3028 77.4725L58.2807 65.2387C57.2433 64.0872 57.3368 62.3137 58.4894 61.2774Z",
    fill: "#2A5877"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9209 16.2621V5.25171H21.5366V16.2621H15.9209Z",
    fill: "#2A5877"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9209 75.5961V64.5857H21.5366V75.5961H15.9209Z",
    fill: "#2A5877"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3679 60.5574L110.58 60.5574V66.1671L60.3679 66.1671V60.5574Z",
    fill: "#2A5877"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64478 60.5574H28.5261C30.0768 60.5574 31.3339 61.8132 31.3339 63.3623C31.3339 64.9114 30.0768 66.1671 28.5261 66.1671H4.64478V60.5574Z",
    fill: "#2A5877"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9919 21.9202V19.3206H84.6077V21.9202H78.9919ZM78.9919 32.319V27.1196H84.6077V32.319H78.9919ZM78.9919 42.7177V37.5184H84.6077V42.7177H78.9919ZM78.9919 53.1165V47.9171H84.6077V53.1165H78.9919ZM78.9919 60.9156V58.3159H84.6077V60.9156H78.9919Z",
    fill: "#2A5877"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3923 21.7673V19.3206H35.0081V21.7673H29.3923ZM29.3923 31.5544V26.6609H35.0081V31.5544H29.3923ZM29.3923 38.8947V36.4479H35.0081V38.8947H29.3923Z",
    fill: "#2A5877"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9429 30.6561L76.5855 88.9579C76.6086 88.9634 76.6319 88.9689 76.6555 88.9746C77.2936 89.1272 78.1735 89.3619 79.1372 89.6916C80.9077 90.2971 83.567 91.4169 85.1915 93.3867C89.755 98.9202 88.6646 106.587 83.7348 111.271C78.2368 116.495 69.4834 116.076 64.4152 110.516C63.0933 109.066 62.441 107.247 62.1128 105.595C61.78 103.92 61.735 102.19 61.7999 100.687C61.8652 99.1709 62.0467 97.7981 62.2097 96.8093C62.2246 96.7186 62.2394 96.6309 62.2541 96.5463L57.1534 90.3969L50.7426 97.0769C51.0222 98.0029 51.3171 99.2448 51.4412 100.663C51.7112 103.748 51.176 107.954 47.5845 111.292C44.1523 114.483 40.1628 115.249 36.7991 114.935C33.561 114.633 30.6812 113.315 29.1306 111.965C26.6274 109.786 24.8237 106.901 24.4019 103.562C23.9751 100.184 25.0073 96.6948 27.5341 93.4485C29.9376 90.3607 33.13 89.1992 35.5708 88.7975C36.7002 88.6116 37.7042 88.5807 38.4622 88.601L47.7894 79.1074L26.9429 53.9746V30.6561ZM51.3913 83.45L40.5223 94.513L39.0883 94.2671C39.0864 94.2668 39.0839 94.2665 39.0808 94.266C39.0621 94.2634 39.0232 94.2581 38.966 94.2517C38.8512 94.2389 38.6654 94.2219 38.4242 94.2125C37.9368 94.1934 37.2517 94.2063 36.4837 94.3326C34.9444 94.586 33.2381 95.2595 31.9674 96.8919C30.2079 99.1524 29.7616 101.183 29.9734 102.859C30.19 104.574 31.1418 106.275 32.8202 107.736C33.3776 108.221 35.1073 109.143 37.321 109.35C39.4092 109.544 41.7138 109.087 43.7587 107.186C45.6442 105.433 46.0275 103.216 45.8468 101.151C45.7565 100.12 45.5264 99.1986 45.315 98.5315C45.2104 98.2017 45.1136 97.9441 45.0471 97.778C45.014 97.6952 44.9887 97.6359 44.9742 97.6027L44.9616 97.5742L44.9605 97.5719L44.1483 95.8419L53.5468 86.0487L51.3913 83.45ZM67.9981 96.4311L67.9966 96.4379L67.9838 96.4943C67.9718 96.548 67.9534 96.6327 67.9303 96.7452C67.884 96.9705 67.8193 97.3049 67.7508 97.7209C67.6127 98.5585 67.4634 99.6985 67.4104 100.928C67.3568 102.171 67.4057 103.419 67.621 104.502C67.8408 105.608 68.1907 106.326 68.5672 106.739C71.5559 110.017 76.692 110.221 79.8645 107.207C82.9353 104.289 83.3145 99.9333 80.8572 96.9537C80.3047 96.2838 78.9837 95.5685 77.3182 94.9989C76.564 94.7409 75.862 94.5531 75.3477 94.4301C75.0923 94.369 74.8877 94.3249 74.7516 94.297C74.6836 94.2831 74.6331 94.2732 74.6022 94.2673L74.5709 94.2614L74.5692 94.2611L74.5669 94.2607L73.5784 94.0846L32.5586 45.9098V51.9525L68.3223 95.0698L67.9989 96.428L67.9981 96.4311Z",
    fill: "#2A5877"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4517 103.197C75.1693 103.197 75.751 102.616 75.751 101.899C75.751 101.182 75.1693 100.601 74.4517 100.601C73.7342 100.601 73.1525 101.182 73.1525 101.899C73.1525 102.616 73.7342 103.197 74.4517 103.197ZM74.4517 107.404C77.4954 107.404 79.9628 104.939 79.9628 101.899C79.9628 98.8584 77.4954 96.3937 74.4517 96.3937C71.4081 96.3937 68.9407 98.8584 68.9407 101.899C68.9407 104.939 71.4081 107.404 74.4517 107.404Z",
    fill: "#2A5877"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7113 103.197C38.4288 103.197 39.0105 102.616 39.0105 101.899C39.0105 101.182 38.4288 100.601 37.7113 100.601C36.9937 100.601 36.412 101.182 36.412 101.899C36.412 102.616 36.9937 103.197 37.7113 103.197ZM37.7113 107.404C40.7549 107.404 43.2223 104.939 43.2223 101.899C43.2223 98.8584 40.7549 96.3937 37.7113 96.3937C34.6676 96.3937 32.2002 98.8584 32.2002 101.899C32.2002 104.939 34.6676 107.404 37.7113 107.404Z",
    fill: "#2A5877"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.54ca42f83506a23a072e5ed30074bd49.svg";
export { ForwardRef as ReactComponent };